<div [class]="(isMobile$ | async) ? 'container-fluid py-4' : 'container-fluid py-4 main-container'">
  <!-- Heading -->
  <div class="py-4 heading-container">
    <h1 class="d-inline-block align-middle m-0" data-test-id="page-heading">
      {{ pageTitle | translate }}
    </h1>
  </div>

  <!-- Add new disease/specialty button -->
  <div>
    <button class="btn btn-primary" type="button" data-test-id="create-btn" (click)="openDialog()">
      {{ createButtonLabel | translate }}
    </button>
  </div>

  <!--tabs selector-->
  <ng-container *ngIf="listState$ | async as listState">
    <div class="tab-holder custom-tabs">
      <ul
        *ngIf="tabs.length"
        ngbNav
        #nav="ngbNav"
        class="nav-tabs"
        [activeId]="listState.context"
        (navChange)="onTabClick($event)"
      >
        <li *ngFor="let tab of tabs" [ngbNavItem]="tab.path" [attr.data-test-id]="tab.path + '-tab'">
          <a ngbNavLink>{{ tab.label | translate }} </a>
        </li>
      </ul>
    </div>

    <div class="w-75">
      <app-search-input
        [label]="'SEARCH_CATEGORY_FIELD_LABEL' | translate: { categoryType: categoryTypeLabel }"
        [value]="listState.queryKeyword"
        (valueChanged)="onKeywordChanged($event)"
      ></app-search-input>
    </div>

    <div *ngIf="listState.pagination.totalItemsCount" class="mt-3">
      <app-sort-drop-down
        [ascending]="(sortParams$ | async).ascending"
        [currentSortCategory]="(sortParams$ | async).orderType"
        [isLoading]="false"
        [sortOptions]="SORT_OPTIONS"
        (toggleSortingByType)="toggleSortingOrderByType($event)"
      >
      </app-sort-drop-down>
    </div>

    <ng-container *ngIf="!listState.pagination.totalItemsCount && listState.mode === ListMode.SEARCH">
      <p
        class="p-3"
        data-test-id="empty-list-hint"
        [innerHTML]="'SEARCH_NO_RESULT_HINT' | translate: { keyword: listState.queryKeyword }"
      ></p>
    </ng-container>

    <!-- Categories table -->
    <div *ngIf="(categories$ | async).length" class="table-responsive categories-table">
      <table class="table">
        <thead class="hide-element position-relative">
          <tr>
            <th scope="col" class="col-md-10">
              <span>{{ 'CATEGORY_TITLE_LABEL' | translate }}</span>
            </th>
            <th scope="col" class="col-md-2">
              <span>{{ 'CATEGORY_MANAGE_LABEL' | translate }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let category of categories$ | async; index as rowIndex">
            <!-- Parent category row -->
            <tr [attr.data-test-id]="'table-row-' + rowIndex">
              <td [attr.data-test-id]="'table-cell-' + rowIndex">
                <div class="d-flex align-items-center">
                  <span class="me-2" *ngIf="category.subcategories?.length">
                    <svg-icon
                      src="assets/icons/icon-expand.svg"
                      class="icon-expand"
                      [class.rotate-90]="expandedCategories[category.entity_id]"
                      (click)="toggleCategory(category.entity_id)"
                    >
                    </svg-icon>
                  </span>
                  {{ category.title }}
                </div>
              </td>
              <td class="td-buttons">
                <span
                  [attr.data-test-id]="'update-btn-' + rowIndex"
                  data-test-id="update-btn"
                  class="edit-btn btn-link btn bottom-right ps-2 padding-right"
                  (click)="updateCategory(category)"
                >
                  <svg-icon src="assets/icons/icon-pencil.svg" class="icon-pencil"></svg-icon>
                </span>

                <span
                  [attr.data-test-id]="'remove-btn-' + rowIndex"
                  class="btn btn-link icon-cross"
                  (click)="removeCategory(category)"
                >
                  <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
                </span>
              </td>
            </tr>

            <!-- Subcategories rows -->
            <ng-container *ngIf="expandedCategories[category.entity_id] && category.subcategories">
              <tr *ngFor="let subcategory of category.subcategories" class="subcategory-row">
                <td>
                  <div class="ps-4 subcategory-title">{{ subcategory.title }}</div>
                </td>
                <td class="td-buttons">
                  <span
                    class="edit-btn btn-link btn bottom-right ps-2 padding-right"
                    (click)="updateCategory(subcategory)"
                  >
                    <svg-icon src="assets/icons/icon-pencil.svg" class="icon-pencil"></svg-icon>
                  </span>
                  <span class="btn btn-link icon-cross" (click)="removeCategory(subcategory)">
                    <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
                  </span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Pagination controls-->
    <ngb-pagination
      *ngIf="listState.pagination.totalItemsCount > listState.pagination.limit"
      class="w-100 d-flex justify-content-center pagination custom-pagination"
      data-test-id="pagination-component"
      [collectionSize]="listState.pagination.totalItemsCount"
      [(page)]="listState.pagination.currentPage"
      [maxSize]="3"
      [pageSize]="listState.pagination.limit"
      [rotate]="true"
      (pageChange)="onPageChange($event)"
    >
    </ngb-pagination>
  </ng-container>
</div>
